import { Controls } from '@zocdoc/components/src/AppointmentPicker';
import { mockable } from '../../../../../config/mockable';

const controlsResolver = () => Controls;

const MockableControls = mockable(controlsResolver);

export {
    controlsResolver,
    MockableControls as default,
};
